<template>
  <b-modal ref="addSiteTeam" hide-footer hide-header :no-close-on-esc="noCloseOnOutsideClick" :no-close-on-backdrop="noCloseOnOutsideClick">
    <div class="modal-wrapper">
      <div class="heading-row">
        <div class="heading">{{ options.title }}</div>
        <div class="searchbar" v-show="listIsVisible == true">
          <input type="text" placeholder="Search" v-model="searchQuery" @keyup.enter="searchForMember()" />
          <i class="fa fa-search" aria-hidden="true" @click="searchForMember()"></i>
        </div>
        <div class="cross" @click="close()">
          <img src="/static/img/Icon@2x.png" />
        </div>
      </div>
      <div class="body pb-12">
        <div class="with-no-records pt-25 pb-20" v-if="memberList && memberList.length == 0">
          <div class="columns">
            <span>NAME</span>
            <span class="email">EMAIL</span>
            <span>BLINDED</span>
          </div>
          <div class="info-area">No results found</div>
          <div class="new-pi-added pt-25" v-if="memberList && memberList.length == 0">
            <div class="title" v-if="this.options.role == 'Pi'">
              If the PI is not in the list above, invite a new PI to join.
            </div>
            <div class="title" v-else>
              If the person is not in the list above, invite a new person to join.
            </div>
            <div class="fields">
              <b-row>
                <b-col cols="3">
                  <span class="header-text">First name</span>
                  <b-form-input type="text" class="required" v-model="newSite.siteMember.firstName" placeholder="Enter name" name="firstName" @keyup.native="validateFirstName(newSite.siteMember)"></b-form-input>
                  <span v-if="newSite.siteMember && newSite.siteMember.fnameError" class="error-style">{{ newSite.siteMember.fnameErrorText }}</span>
                </b-col>
                <b-col cols="3">
                  <span class="header-text">Last name</span>
                  <b-form-input type="text" class="required" v-model="newSite.siteMember.lastName" placeholder="Enter name" name="lastName" @keyup.native="validateLastName(newSite.siteMember)"></b-form-input>
                  <span v-if="newSite.siteMember && newSite.siteMember.lnameError" class="error-style">{{ newSite.siteMember.lnameErrorText }}</span>
                </b-col>
                <b-col cols="3">
                  <span class="header-text">Role</span>
                  <b-form-input type="text" value="Principal Investigator" :readonly="options.role == 'pi'" v-if="options.role == 'pi'"></b-form-input>
                  <b-form-select class="modal-custom-select" v-validate="'required'" v-model="newSite.siteMember.userRole" name="role" v-if="options.role !== 'pi'">
                    <option disabled value="null">Select</option>
                    <option v-for="role in roles" :value="role.value" :key="role.value"> {{ role.name }}</option>
                  </b-form-select>
                  <span v-if="errors.has('role')" class="error-style">Please select valid role.</span>
                </b-col>
              </b-row>
              <b-row class="pt-10">
                <b-col cols="3">
                  <span class="header-text">Email address</span>
                  <b-form-input type="email" class="required" v-model="newSite.siteMember.username" placeholder="Enter email" @keyup.native="validateEmail(newSite.siteMember)"></b-form-input>
                  <span v-if="newSite.siteMember.emailError" class="error-style">{{ newSite.siteMember.emailErrorText }} </span>
                </b-col>
                <b-col cols="3">
                  <span class="header-text">Phone number</span>
                  <span>
                    <vue-tel-input
                      class="p-0 bg"
                      v-model="newSite.siteMember.phoneNumber"
                      :preferredCountries="['us', 'ca']"
                      :placeholder="'(      )  '"
                      v-bind:class="{
                        input: true,
                        'is-danger': newSite.siteMember.phoneError
                      }"
                      @onInput="onInputPIPhone"
                    ></vue-tel-input>
                    <span v-if="newSite.siteMember.phoneError" class="error-style">{{ newSite.siteMember.phoneErrorText }}</span>
                  </span>
                </b-col>
              </b-row>
              <b-row class="pb-20">
                <b-col cols="3">
                  <div class="site-pi-add">
                    <span class="un-bld-Lbl-Txt">Unblinded</span>
                    <label class="switch">
                      <input type="checkbox" v-model="newSite.siteMember.blinded" />
                      <div class="slider round"></div>
                    </label>
                    <span class="bld-Lbl-Txt">Blinded</span>
                    <span class="info-msg">
                      <i class="fa fa-info-circle help_icon cursor_pointer" v-b-popover.hover="'Enabling the toggle to Blinded will hide all participant responses from this team member. Disabling the toggle to Unblinded will allow this member to view all participant responses.'"></i>
                    </span>
                  </div>
                </b-col>
                <b-col cols="3">
                  <div class="site-pi-add">
                    <span class="un-bld-Lbl-Txt">Read-only</span>
                    <span class="info-msg move-info-left">
                      <i class="fa fa-info-circle help_icon cursor_pointer" v-b-popover.hover="'When Read-only is turned on, the Site Team member will only be able to view information and will not be able to take any actions. This scenario is primarily used during the Close Out/Archiving phase of a clinical trial.'"></i>
                    </span>
                    <span class="un-bld-Lbl-Txt move-left">Off</span>
                    <label class="switch left-switch">
                      <input type="checkbox" v-model="newSite.siteMember.readonly" />
                      <div class="slider round"></div>
                    </label>
                    <span class="bld-Lbl-Txt on-left">On</span>
                  </div>
                </b-col>
                <b-col v-if="!canAccessSSOUsername" cols="6">
                  <div class="submit-btn pull-right">
                    <button class="btn btn-primary" @click="saveSiteTeam()" :disabled="checkIfDisabled">
                      Add
                    </button>
                  </div>
                </b-col>
              </b-row>
              <div class="idp-username-section" v-if="canAccessSSOUsername">
                <div class="additional-details-sso">
                  <span class="line"></span>
                  <div class="additional-sso-title">Additional Details for SSO</div>
                  <div class="desc">Important! Please do not populate this section unless this user’s account is associated with an SSO IdP.</div>
                  <div class="row no-gutters">
                    <div class="col-4">
                      <span class="header-text">IdP Username</span>
                      <b-form-input type="text" v-model.trim="newSite.siteMember.idpUserName" placeholder="Enter IDP Username" name="idpUserName"></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="submit-btn">
                  <button class="btn btn-primary" @click="saveSiteTeam()" :disabled="checkIfDisabled">Add</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="with-no-records pt-25 pb-20" v-if="!listIsVisible">
          <div class="columns">
            <span>NAME</span>
            <span class="email">EMAIL</span>
            <span>ROLE</span>
            <span>BLINDED</span>
          </div>
          <div class="info-area with-btn">
            <span class="selected-member" v-if="options.role !== 'pi' && member.length > 0"
              ><b>{{ member.length }}</b> selected</span
            >
            <button class="btn btn-primary" @click="ViewMemberList()">
              View existing team
            </button>
          </div>
        </div>
        <div class="with-records ml-10 pt-25" v-if="memberList && memberList.length > 0 && listIsVisible">
          <listOfMembers :memberList="memberList" :role="options.role" @saveSitePI="saveSitePI" @switchView="switchView" :listIsVisible="listIsVisible" @saveSiteTeamMember="saveSiteTeamMember" :selectedSiteTeam="member"> </listOfMembers>
        </div>
        <div class="new-pi-added pt-25" v-if="!listIsVisible">
          <div class="title" v-if="this.options.role == 'pi'">
            If the PI is not in the list above, invite a new PI to join.
          </div>
          <div class="title" v-else>
            If the person is not in the list above, invite a new person to join.
          </div>
          <div class="fields">
            <b-row>
              <b-col cols="3">
                <span class="header-text">First name</span>
                <b-form-input type="text" class="required" v-model="newSite.siteMember.firstName" placeholder="Enter name" name="firstName" @keyup.native="validateFirstName(newSite.siteMember)"></b-form-input>
                <span v-if="newSite.siteMember && fnameError" class="error-style">{{ newSite.siteMember.fnameErrorText }}</span>
              </b-col>
              <b-col cols="3">
                <span class="header-text">Last name</span>
                <b-form-input type="text" class="required" v-model="newSite.siteMember.lastName" placeholder="Enter name" name="lastName" @keyup.native="validateLastName(newSite.siteMember)"></b-form-input>
                <span v-if="newSite.siteMember && lnameError" class="error-style">{{ newSite.siteMember.lnameErrorText }}</span>
              </b-col>
              <b-col cols="3">
                <span class="header-text">Role</span>
                <b-form-input type="text" value="Principal Investigator" :readonly="options.role == 'pi'" v-if="options.role == 'pi'"></b-form-input>
                <b-form-select class="modal-custom-select select-arrow" v-validate="'required'" v-model="newSite.siteMember.userRole" name="role" v-if="options.role !== 'pi'">
                  <option disabled value="null">Select</option>
                  <option v-for="role in roles" :value="role.value" :key="role.value"> {{ role.name }}</option>
                </b-form-select>
                <span v-if="errors.has('role')" class="error-style">Please select valid role.</span>
              </b-col>
            </b-row>
            <b-row class="pt-10">
              <b-col cols="3">
                <span class="header-text">Email address</span>
                <b-form-input type="email" class="required" v-model="newSite.siteMember.username" placeholder="Enter email" @keyup.native="validateEmail(newSite.siteMember)"></b-form-input>
                <span v-if="this.emailError" class="error-style">{{ newSite.siteMember.emailErrorText }} </span>
              </b-col>
              <b-col cols="3">
                <span class="header-text">Phone number</span>
                <span>
                  <vue-tel-input
                    class="p-0 bg"
                    v-model="newSite.siteMember.phoneNumber"
                    :preferredCountries="['us', 'ca']"
                    :placeholder="'(      )  '"
                    @onInput="onInputPIPhone"
                    v-bind:class="{
                      input: true,
                      'is-danger': newSite.siteMember.phoneError
                    }"
                  ></vue-tel-input>
                  <span v-if="phoneError" class="error-style">{{ newSite.siteMember.phoneErrorText }}</span>
                </span>
              </b-col>
            </b-row>
            <b-row class="pb-20">
              <b-col cols="3">
                <div class="site-pi-add">
                  <span class="un-bld-Lbl-Txt">Unblinded</span>
                  <label class="switch">
                    <input type="checkbox" v-model="newSite.siteMember.blinded" />
                    <div class="slider round"></div>
                  </label>
                  <span class="bld-Lbl-Txt">Blinded</span>
                  <span class="info-msg">
                    <i class="fa fa-info-circle help_icon cursor_pointer" v-b-popover.hover="'Enabling the toggle to Blinded will hide all participant responses from this team member. Disabling the toggle to Unblinded will allow this member to view all participant responses.'"></i>
                  </span>
                </div>
              </b-col>
              <b-col cols="3">
                <div class="site-pi-add">
                  <span class="un-bld-Lbl-Txt">Read-only</span>
                  <span class="info-msg move-info-left">
                    <i class="fa fa-info-circle help_icon cursor_pointer" v-b-popover.hover="'When Read-only is turned on, the Site Team member will only be able to view information and will not be able to take any actions. This scenario is primarily used during the Close Out/Archiving phase of a clinical trial.'"></i>
                  </span>
                  <span class="un-bld-Lbl-Txt move-left">Off</span>
                  <label class="switch left-switch">
                    <input type="checkbox" v-model="newSite.siteMember.readonly" />
                    <div class="slider round"></div>
                  </label>
                  <span class="bld-Lbl-Txt on-left">On</span>
                </div>
              </b-col>
              <b-col v-if="!canAccessSSOUsername" cols="6">
                <div class="submit-btn pull-right">
                  <button class="btn btn-primary" @click="saveSiteTeam()" :disabled="checkIfDisabled">
                    Add
                  </button>
                </div>
              </b-col>
            </b-row>
            <div class="idp-username-section" v-if="canAccessSSOUsername">
              <div class="additional-details-sso">
                <span class="line"></span>
                <div class="additional-sso-title">Additional Details for SSO</div>
                <div class="desc">Important! Please do not populate this section unless this user’s account is associated with an SSO IdP.</div>
                <div class="row no-gutters">
                  <div class="col-4">
                    <span class="header-text">IdP Username</span>
                    <b-form-input type="text" v-model="newSite.siteMember.idpUserName" placeholder="Enter IDP Username" name="idpUserName"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="submit-btn">
                <button class="btn btn-primary" @click="saveSiteTeam()" :disabled="checkIfDisabled">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import listOfMembers from "@/components/research-team/list-of-members";
import { SYSTEM_ADMIN, STUDY_ADMIN, SUPPORT } from "@/constants/authRoles";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import regExpUtil from "../../utils/regExpUtil";
import { getUserRoles } from "@/components/services/auth-service";
import { LOAD_SITE_ROLES } from "@/constants/actions";
export default {
  name: "add-site-team-members",
  data() {
    return {
      roles: [],
      title: null,
      noCloseOnOutsideClick: true,
      newSite: {
        siteMember: {
          firstName: null,
          lastName: null,
          username: null,
          phoneNumber: null,
          userRole: null,
          blinded: false,
          readonly: false,
          idpUserName: null
        }
      },
      emailError: true,
      phoneError: true,
      lnameError: true,
      fnameError: true,
      memberList: [],
      members: [],
      listIsVisible: true,
      member: [],
      searchQuery: null,
      existingList: this.memberList,
      piCountryCode: null,
      studyId: this.$route.params.studyId,
      siteID: this.$route.params.siteId
    };
  },
  props: {
    isPopupEnabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {}
    },
    allActivePis: {
      type: Array
    },
    allActiveSiteTeamMember: {
      type: Array
    },
    isRoleDropdownDisabled: {
      type: Boolean
    },
    siteTeamList: {
      type: Array
    },
    isResearchSiteDetailsModal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["user", "awsCognitoAuthentication"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    checkIfDisabled() {
      if (!this.emailError && !this.lnameError && !this.fnameError) {
        return false;
      }
      return true;
    },
    canAccessSSOUsername() {
      if (this.awsCognitoAuthentication && this.awsCognitoAuthentication === true && (this.canSysAdminAccess || this.canStudyAdminAccess || this.canSupportAccess)) {
        return true;
      }
      return false;
    }
  },
  watch: {
    isPopupEnabled: {
      handler(val) {
        if (val || this.$refs["addSiteTeam"].is_hidden === false) {
          this.$refs["addSiteTeam"].show();
        }
      }
    },
    options: {
      handler(val) {
        if (val.role == "pi") {
          this.memberList = this.allActivePis;
        } else {
          this.memberList = this.allActiveSiteTeamMember;
        }
      }
    },
    isRoleDropdownDisabled: {
      handler(val) {
        this.isRoleDropdownDisabled = val;
      }
    }
  },
  components: { listOfMembers },
  methods: {
    close() {
      this.memberList = [];
      this.searchQuery = "";
      this.$refs["addSiteTeam"].hide();
      this.listIsVisible = true;
      this.$root.$emit("resetAllTheValues");
    },
    validateEmail(teamMember) {
      const member = teamMember;
      const email = member.username ? member.username.trim() : null;
      const emailPattern = new RegExp("^[_\\+A-Za-z0-9-\\+]+(\\.[_\\+A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$");
      if (email == "" || email == null) {
        member.emailErrorText = "Email is required";
        this.emailError = true;
      } else if (email && !emailPattern.test(email)) {
        member.emailErrorText = "Please enter a valid email address.";
        this.emailError = true;
      } else {
        member.emailErrorText = null;
        this.emailError = false;
        this.$forceUpdate();
      }
    },
    onInputPIPhone({ number, isValid, country }) {
      this.phoneError = false;
      if (!isValid && number.length > 0) {
        this.newSite.siteMember.phoneErrorText = "Please enter a valid phone number.";
        this.phoneError = true;
      } else {
        this.newSite.siteMember.phoneErrorText = null;
        this.phoneError = false;
        this.$forceUpdate();
        this.piCountryCode = country.dialCode;
      }
    },
    validateFirstName(teamMember) {
      const member = teamMember;
      const pattern = new RegExp("^[A-Za-z- ]+$");
      const fname = member.firstName ? member.firstName.trim() : null;
      if (!fname) {
        member.fnameErrorText = "First name is required";
        this.fnameError = true;
      } else if (!pattern.test(fname)) {
        member.fnameErrorText = "Alphabetic entries only are allowed";
        this.fnameError = true;
      } else {
        this.fnameError = false;
        member.fnameErrorText = null;
      }
      this.$forceUpdate();
    },
    validateLastName(teamMember) {
      const member = teamMember;
      const pattern = new RegExp("^[A-Za-z- ]+$");
      const lname = member.lastName ? member.lastName.trim() : null;
      if (!lname) {
        member.lnameErrorText = "Last name is required";
        this.lnameError = true;
      } else if (!pattern.test(lname)) {
        member.lnameErrorText = "Alphabetic entries only are allowed";
        this.lnameError = true;
      } else {
        this.lnameError = false;
        member.lnameErrorText = null;
      }
      this.$forceUpdate();
    },
    switchView(flag, team) {
      this.listIsVisible = flag != null ? !flag : !this.listIsVisible;
      this.newSite.siteMember.userRole = null;
      if (team) {
        this.member = [];
        this.member = team;
      }
    },
    ViewMemberList() {
      this.listIsVisible = !this.listIsVisible;
    },
    searchForMember() {
      this.$emit("searchForMember", {
        role: this.options.role,
        searchQuery: this.searchQuery
      });
    },
    saveSiteTeam() {
      const idpUserName = this.newSite.siteMember.idpUserName;
      const specialCharactersRegex = regExpUtil.commonValidations.S;

      const hasInvalidSpaces = idpUserName && idpUserName.includes(" ");
      const hasInvalidLength = idpUserName && (idpUserName.length < 8 || idpUserName.length > 128);
      const hasInvalidFirstOrLastCharacter = idpUserName && (specialCharactersRegex.test(idpUserName.charAt(0)) || specialCharactersRegex.test(idpUserName.charAt(idpUserName.length - 1)));

      if (hasInvalidSpaces || hasInvalidLength || hasInvalidFirstOrLastCharacter) {
        this.$toastr.error("Invalid IdP username, this username cannot be saved");
        return;
      }

      if (this.newSite.siteMember.phoneNumber) {
        if (this.newSite.siteMember.phoneNumber.includes("+")) {
          this.newSite.siteMember.phoneNumber = this.newSite.siteMember.phoneNumber.replace(`+${this.piCountryCode}`, "");
          this.newSite.siteMember.phoneNumber = `+${this.piCountryCode}${this.newSite.siteMember.phoneNumber}`;
        } else {
          this.newSite.siteMember.phoneNumber = `+${this.piCountryCode}${this.newSite.siteMember.phoneNumber}`;
        }
      }
      if (this.siteTeamList) {
        const found = this.siteTeamList.some(item => item.username == this.newSite.siteMember.username);
        if (found) {
          this.$toastr.error("This email already exists.");
          return;
        }
      }
      if ((this.newSite.siteMember.userRole == "" || this.newSite.siteMember.userRole == null) && this.options.role !== "pi") {
        this.$toastr.error("Please select user role.");
        return;
      }
      if (this.options.role == "pi") {
        this.newSite.siteMember.userRole = "Pi";
        this.member = this.newSite.siteMember;
      } else {
        this.member.push(this.newSite.siteMember);
      }

      if (this.isResearchSiteDetailsModal) {
        this.addSiteTeamMembers(true);
      } else {
        this.clearModal();
      }
    },
    addSiteTeamMembers(isNewMember = false) {
      return this.$api.addSiteTeamMembers(this.studyId, this.siteID, this.member).then(
        () => {
          this.$toastr.success("Team member added successfully.");

          this.clearModal();
        },
        error => {
          if (error.body) {
            this.$toastr.error(error.body.message);
          }

          if (isNewMember) {
            this.member.pop();
          }
        }
      );
    },
    clearModal() {
      this.close();
      this.$refs["addSiteTeam"].hide();
      this.listIsVisible = true;
      this.newSite = {
        siteMember: {
          firstName: null,
          lastName: null,
          username: null,
          phoneNumber: null,
          userRole: null,
          idpUserName: null,
          blinded: false,
          readonly: false,
          emailError: true,
          phoneError: false,
          lnameError: true,
          fnameError: true
        }
      };
      this.$emit("getSiteTeamSelected", this.member, this.options.role);
      this.member = [];
    },
    async saveSitePI(data) {
      this.searchQuery = "";
      this.member = data;
      this.$refs["addSiteTeam"].hide();
      this.listIsVisible = true;

      if (this.isResearchSiteDetailsModal) {
        await this.addSiteTeamMembers();
      }

      this.$emit("getSiteTeamSelected", this.member, "pi");
    },
    async saveSiteTeamMember(data) {
      this.searchQuery = "";
      this.member = data;
      this.$refs["addSiteTeam"].hide();
      this.listIsVisible = true;

      if (this.isResearchSiteDetailsModal) {
        await this.addSiteTeamMembers();
      }

      this.$emit("getSiteTeamSelected", this.member, "team", this.mode);
      this.member = [];
    }
  },
  async mounted() {
    this.$root.$on("memberDeleted", () => {
      this.listIsVisible = true;
    });
    this.$root.$on("memberReset", () => {
      this.member = [];
    });

    await this.$store.dispatch(LOAD_SITE_ROLES);
    this.roles = getUserRoles(true);
  }
};
</script>

<style lang="scss" scoped>
/deep/ .modal-dialog {
  width: 850px;
  max-width: 850px;
  padding: 0px;
}
/deep/ .form-control {
  padding: 6px 20px 6px 5px;
}
/deep/ .modal-body {
  padding: 0;
}
.modal-wrapper {
  .heading-row {
    position: relative;
    padding: 1rem;
    .heading {
      color: #2d3752;
      font-weight: 600;
      font-size: 17px;
      width: 260px;
      display: inline-block;
    }
    .searchbar {
      display: inline-block;
      width: 243px;
      position: absolute;
      right: 40px;
      input {
        width: 100%;
        border: solid 2px #d3dfe4;
        border-radius: 3px;
        padding: 5px;
        padding-right: 32px;
      }
      .fa-search {
        position: absolute;
        right: 8px;
        font-size: 21px;
        color: #d3dfe4;
        top: 8px;
        cursor: pointer;
      }
    }
    .cross {
      width: 24px;
      height: 24px;
      display: inline-block;
      position: absolute;
      right: 4px;
      top: 10px;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
  }
  .body {
    .with-no-records {
      .columns {
        span {
          display: inline-block;
          width: 21%;
          text-align: center;
          color: #666669;
          font-size: 10px;
          opacity: 0.7;
          &.email {
            width: 31%;
          }
        }
      }
      .info-area {
        background-color: #f5f8fa;
        height: 85px;
        width: 100%;
        text-align: center;
        padding-top: 30px;
        opacity: 0.6;
        &.with-btn {
          opacity: 1;
        }
        .btn-primary {
          border-radius: 4px;
          border: solid 1.5px #c5d1d6;
          background-color: #ffffff;
          color: #4c8ce4;
          font-size: 13px;
        }
        .selected-member {
          padding-right: 12px;
          color: #4c8ce4;
        }
      }
    }
    .new-pi-added {
      .title {
        color: #000;
        padding-left: 15px;
        padding-bottom: 12px;
      }
      .fields {
        .header-text {
          color: #666669 !important;
          opacity: 0.5;
          font-size: 14px;
        }
        input {
          font-size: 12px;
        }
        .submit-btn {
          .btn-primary {
            position: relative;
            top: 17px;
            width: 100px;
            border-radius: 25px;
            right: 22px;
            background: #4c8ce4;
          }
        }
      }
      .with-list {
        &.col-9 {
          max-width: 72.3%;
        }
        .submit-btn {
          .btn-primary {
            padding: 6px 35px;
            border-radius: 25px;
            background: #4c8ce4;
          }
        }
      }

      .idp-username-section {
        .submit-btn {
          text-align: right;
          margin-bottom: 11px;
          padding-right: 24px;
          button {
            &.btn {
              &.btn-primary {
                position: inherit;
              }
            }
          }
        }
        .additional-details-sso {
          border-bottom: 1px solid #d4d4d3;
          margin-left: 13px;
          margin-right: 13px;
          margin-bottom: 25px;
          padding-bottom: 23px;
          .additional-sso-title {
            color: #4a4a4a;
            font-family: Roboto-Medium;
            font-size: 16px;
            display: flex;
            align-items: center;
            &::after {
              content: "";
              flex: 1;
              margin-left: 1rem;
              height: 1px;
              background-color: #d4d4d3;
              margin-top: 15px;
            }
          }
          .desc {
            margin-top: 16px;
            margin-bottom: 19px;
            color: #666669;
            font-family: Roboto-Regular;
            font-size: 12px;
          }
          input {
            background: #f5f8fa;
          }
        }
      }
    }
  }
}
.btn-wrapper {
  width: 64%;
}

// extra css inherit from another component
.required {
  background: url("/static/img/required.svg") no-repeat right #f5f8fa !important;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.is-danger {
  border-color: #ff4848 !important;
  border-width: 1px !important;
}
/* The slider */
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 27px;
  &.left-switch {
    left: 14px;
  }
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: 14px;
  right: 10px;
  &.move-left {
    left: 5px;
  }
}
.bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: 14px;
  left: 5px;
  &.on-left {
    left: 21px;
  }
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 10px;
  top: 14px;
  &.move-info-left {
    left: -3px;
  }
}
.site-mem-add {
  position: relative;
  bottom: 20px;
  right: 10px;
}
.site-pi-add {
  position: relative;
  bottom: 5px;
  left: 8px;
  height: 50px;
}
.site-pi-lock {
  position: relative;
  bottom: 5px;
  left: 2px;
  height: 50px;
}
.info-msglock {
  position: relative;
  top: 14px;
  right: 5px;
}
.siteteam-info {
  position: relative;
  right: 15px;
}
.removelink {
  position: relative;
  left: 40px;
}
.Add-a-Site-Team-memb {
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: bold;
  color: #4c8ce4;
  background: #fff;
  margin-right: 302px;
  margin-top: 20px;
}
.popover {
  font-size: 12px !important;
  font-family: "Lato-regular" !important;
}
.popover-body {
  color: #666666 !important;
}
.select-arrow {
  background: url("/static/img/required.svg") no-repeat right, url("/static/img/arrow-down.png") no-repeat bottom 6px right 18px #f5f8fa !important;
}
</style>
<style scoped lang="scss" src="@/assets/range-slider.scss">
</style>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss">
</style>
